export default __webpack_public_path__ + "static/media/3.50fc4d51.svg";